// Suresh Peddavoora 10/20/2022 2698777930 - Removed height property, as it is effecting for button overlapping.
/*
saimaheshwar 10/13/2022  2700872024  added scroll for add client rates
Suresh Peddavoora 10/30/2022 2698777930 - Added classname for textfield enhancements.

*/
import React, {memo} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import ServiceTypeAccordion from './ServiceTypeAccordion';
const useStyles = makeStyles((theme) => ({
  customTable: {
    'backgroundColor': '#32046926',
    '& .MuiSvgIcon-root': {
      fill: 'currentColor !important',
    },
    '& .MuiCheckbox-colorPrimary.Mui-checked': {
      color: '#320469',
    },
    '& .MuiInputBase-input.Mui-disabled': {
      opacity: '1 !important',
    },
    '& .MuiFormControlLabel-root': {
      marginLeft: '11px !important',
    },
    // Kept for future reference
    // "& .MuiOutlinedInput-inputMarginDense": {
    //   paddingTop: "8px !important",
    //   paddingBottom: "8px !important"
    // },
  },
  inputStyles: {
    '& .MuiTypography-root': {
      padding: '0px !important',
    },
    '& .MuiOutlinedInput-root': {
      padding: '0px 10px',
      justifyContent: 'center',
    },
    '& .MuiOutlinedInput-input': {
      padding: '10px 3px 10px 6px',
      width: '85px',
    },
    '& .MuiIconButton-root': {
      padding: '0px',
    },
    '& .MuiInputBase-root.Mui-disabled': {
      color: 'black !important',
    },
  },

  notesInputStyles: {
    '& .MuiInputBase-inputMultiline': {
      width: '16rem',
    },
    '& .MuiInputBase-input': {
      color: '#191616 !important',
      fontWeight: '600 !important',
    },
  },
}));
const ClientFormSubServiceTypeTable = memo(({formik, setBlockScroll, blockScroll}) => {
  const componentClasses = useStyles();
  return (
    <div className={`mui-custom-table-container global-field-textfields ${componentClasses.customTable} pt-0 mb-3`}>
      <table>
        <thead className="recFormat-header-container">
          <tr>
            <th style={{textAlign: 'left'}}>Service Type</th>
          </tr>
        </thead>
        <tbody className="recFormat-body">
          {formik?.values?.serviceType?.map((serviceType) => {
            return (
              <div className="m-2" key={serviceType?.serviceTypeId}>
                <ServiceTypeAccordion
                  key={serviceType?.serviceTypeId}
                  formik={formik}
                  serviceType={serviceType}
                  setBlockScroll={setBlockScroll}
                  blockScroll={blockScroll}
                />
              </div>
            );
          })}
        </tbody>
      </table>
    </div>
  );
});

ClientFormSubServiceTypeTable.displayName = 'ClientFormSubServiceTypeTable';
export default ClientFormSubServiceTypeTable;
